export const defaultConfig = {
    baseAPIUrl: "https://islandmotors.shop/backend/index.php/api/",


    //BT
    // baseAPIUrl: "https://laravel9.etrueconcept.com/island_motors/api/",
    //Local
    // baseAPIUrl: "http://192.168.0.219/island_motors/api/",

};       